import { BillingTier } from "../__generated__/gql/graphql";

export const billingTierLabel: Record<BillingTier, string> = {
  [BillingTier.Free]: "Free",
  [BillingTier.Starter]: "Starter",
  [BillingTier.Pro]: "Pro",
  [BillingTier.Scale]: "Scale",
};

export const billingTierPrice: {
  monthly: Record<BillingTier, number>;
  yearly: Record<BillingTier, number>;
} = {
  monthly: {
    [BillingTier.Free]: 0,
    [BillingTier.Starter]: 89,
    [BillingTier.Pro]: 299,
    [BillingTier.Scale]: 899,
  },
  yearly: {
    [BillingTier.Free]: 0,
    [BillingTier.Starter]: 59,
    [BillingTier.Pro]: 199,
    [BillingTier.Scale]: 599,
  },
};

export const billingTierRank: Record<BillingTier, number> = {
  [BillingTier.Free]: 0,
  [BillingTier.Starter]: 1,
  [BillingTier.Pro]: 2,
  [BillingTier.Scale]: 3,
};
